import * as Sentry from '@sentry/browser'

/**
 * Diagnostics for the session-expiry / logout stack overflow.
 *
 * ClickUp: https://app.clickup.com/t/86c5a6rvm
 * Search Sentry for: CU-86c5a6rvm or ETRAINER-APP-280
 *
 * Only primitives in `data` — Axios/Vue objects here can themselves
 * RangeError while Sentry serializes the breadcrumb.
 */
export const SESSION_RANGEERROR_TASK = {
    clickUpTaskId: '86c5a6rvm',
    relatedSentryIssue: 'ETRAINER-APP-280',
}

export const addSessionBreadcrumb = (message, data = {}) => {
    try {
        Sentry.setTag('clickup_task', SESSION_RANGEERROR_TASK.clickUpTaskId)
        Sentry.setTag('related_issue', SESSION_RANGEERROR_TASK.relatedSentryIssue)

        Sentry.addBreadcrumb({
            category: 'session',
            level: 'info',
            message: `[CU-${SESSION_RANGEERROR_TASK.clickUpTaskId}][${SESSION_RANGEERROR_TASK.relatedSentryIssue}] ${message}`,
            data: {
                clickUpTaskId: SESSION_RANGEERROR_TASK.clickUpTaskId,
                relatedSentryIssue: SESSION_RANGEERROR_TASK.relatedSentryIssue,
                ...data,
            },
        })
    } catch (e) {
        // Diagnostics must never crash the app
    }
}
